import './contactUs.css';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { FormattedMessage } from 'react-intl';
import { useDevice } from '../../contexts/DeviceContext';
import { getCurrentLayout } from '../../utils/ChooseLayout';
import { FooterContent } from '../../graphql/pimcore/modules/siteContent/types/FooterContent';
import { Link } from 'react-router-dom';
import { LinkCollectionEntry } from '../../graphql/pimcore/modules/siteContent/types/SiteContentElement';
import { isLinkCollectionEntryInternal } from '../../graphql/pimcore/modules/siteContent/guards/SiteContentElement';

type ContactUsSelectProps = {
    cmsContent: FooterContent;
};

function LinkItem({ link }: { link: LinkCollectionEntry }) {
    return isLinkCollectionEntryInternal(link) ? (
        <Link className="a-styling" to={link.linkRoute}>
            {link.linkText}
        </Link>
    ) : (
        <a
            className="a-styling"
            href={link.linkUrl}
            target="_blank"
            rel="nofollow noopener noreferrer"
        >
            {link.linkText}
        </a>
    );
}

export default function ContactUsSelect({ cmsContent }: ContactUsSelectProps) {
    const { width } = useDevice();
    const layout = getCurrentLayout(width);
    const { left: leftColumn, right: rightColumn } = cmsContent;

    return (
        <div className="ul-select">
            <Accordion
                defaultExpanded={false}
                style={{
                    background: '#F2F2F2',
                    boxShadow: 'none',
                    marginLeft: layout === 'extra_small' ? '0' : '2rem',
                }}
            >
                <AccordionSummary
                    sx={{
                        pl: 0,
                        width: layout === 'extra_small' ? '100%' : '24rem',
                    }}
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                >
                    <div style={{ fontSize: '1.125rem', fontWeight: '500' }}>
                        {leftColumn.title.content}
                        <hr
                            style={{
                                width: layout === 'extra_small' ? '17.1rem' : '25rem',
                                fontWeight: 700,
                            }}
                        />
                    </div>
                </AccordionSummary>
                <AccordionDetails sx={{ paddingLeft: 0 }}>
                    <ul className="ul-styling">
                        {leftColumn.links.links.map((link, index) => (
                            <li
                                key={link.linkText}
                                style={{ marginTop: index === 0 ? '-0.5rem' : '0.6rem' }}
                            >
                                <LinkItem link={link} />
                            </li>
                        ))}
                    </ul>
                </AccordionDetails>
            </Accordion>
            <Accordion
                defaultExpanded={false}
                style={{
                    background: '#F2F2F2',
                    boxShadow: 'none',
                    marginLeft: layout === 'extra_small' ? '0' : '2rem',
                }}
            >
                <AccordionSummary
                    sx={{
                        pl: 0,
                        width: layout === 'extra_small' ? '100%' : '24rem',
                    }}
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel2-header"
                >
                    <div style={{ fontSize: '1.125rem', fontWeight: '500' }}>
                        {rightColumn.title.content}
                        <hr
                            style={{
                                width: layout === 'extra_small' ? '17.1rem' : '25rem',
                                fontWeight: 700,
                            }}
                        />
                    </div>
                </AccordionSummary>
                <AccordionDetails sx={{ paddingLeft: 0 }}>
                    <ul className="ul-styling2">
                        <li style={{}}>
                            <a className="a-styling" href={'/SalesResources/ResourceLibrary'}>
                                <FormattedMessage id="Resources" defaultMessage="Resources" />
                            </a>
                        </li>
                        {rightColumn.links.links.map((link, index) => (
                            <li key={link.linkText} style={{ marginTop: '0.6rem' }}>
                                <LinkItem link={link} />
                            </li>
                        ))}
                    </ul>
                </AccordionDetails>
            </Accordion>
        </div>
    );
}
